import { apiSlice } from './apiSlice';
import { IAppVersion } from '@Types/AppVersionType';

type CreateAppVersionPayload = {
  Platform: number;
  VersionTag: string;
  PolicyType: number;
};

export const appVersionsApi = apiSlice.injectEndpoints({
  
  endpoints: (builder) => ({
    getAllAppVersions: builder.query<{ items: IAppVersion[]; count: number }, any>({
      query: (body) => ({
        url: '/api/app/version/GetAll',
        method: 'POST',
        body,
      }),
      providesTags: (result, error, body) => {
        return [
          { type: 'AppVersions', id: 'LIST' },
          { type: 'AppVersions', id: `PAGE-${body.currentPage}` },
        ];
      },
    }),
    createAppVersion: builder.mutation<void, CreateAppVersionPayload>({
      query: (newVersion) => ({
        url: '/api/app/version/Add',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: newVersion,
      }),
      invalidatesTags: [{ type: 'AppVersions', id: 'LIST' }],
    }),
    removeAppVersion: builder.mutation<void, string>({
      query: (id) => ({
        url: `/api/app/version/Remove?id=${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetAllAppVersionsQuery,
  useCreateAppVersionMutation,
  useRemoveAppVersionMutation,
} = appVersionsApi;